import React from 'react'
import Footer from 'components/layout/Footer/index'
import NewHeader from 'components/layout/NewHeader/index'
import RightSidebar from 'components/RightSidebar/index'
import useGameMaintenanceCheck from 'hooks/useGameMaintenanceCheck'

const PublicRoute = ({ Component, isHeader, isFooter, child, gameId, showSidebar = true }) => {
  useGameMaintenanceCheck(gameId)

  return (
    <>
      {/* {isHeader ? <NewHeader /> : <></>} */}
      <div className={isHeader ? '' : 'd-none'}>
        <NewHeader />
      </div>
      <Component child={child} />
      {showSidebar && <RightSidebar />}
      {isFooter ? <Footer /> : <></>}
    </>
  )
}

export default PublicRoute
